import { z } from 'zod';

export const SideNavItemSchema = z.object({
  title: z.string(),
  tooltip: z.string().optional(),
  routerLink: z.string(),
  icon: z.enum(['asset', 'folder', 'integrations', 'logoutSvg', 'default', 'settings', 'credit-card', 'users', 'billing', 'team', 'search']).optional(),
  acl: z.object({
    role: z.union([z.string(), z.array(z.string())]),
    resource: z.string().optional()
  }).optional(),
  dataTestId: z.string().optional()
});

export const SideNavSectionSchema = z.object({
  title: z.string(),
  items: z.array(SideNavItemSchema)
});

export const SideNavSectionsSchema = z.array(SideNavSectionSchema);

// Type inference from schemas (if needed)
export type SideNavItem = z.infer<typeof SideNavItemSchema>;
export type SideNavSection = z.infer<typeof SideNavSectionSchema>;
export type SideNavSections = z.infer<typeof SideNavSectionsSchema>;
